/**
 * Service Users — READ-ONLY
 * La creation/modification des utilisateurs se fait depuis Supabase Auth ou le LMS
 */
import { supabase } from '../config/supabase';
import { User, UserRole } from '../types';

export const usersService = {
  async getAll(): Promise<User[]> {
    const { data, error } = await supabase
      .from('users')
      .select('*')
      .order('email');

    if (error) {
      console.error('Error getting users:', error);
      throw new Error('Impossible de recuperer la liste des utilisateurs');
    }

    return (data || []).map((user) => ({
      id: user.id,
      email: user.email,
      role: user.role as UserRole,
      organizationId: user.organization_id,
      displayName: user.display_name,
      avatarUrl: user.avatar_url,
      lastLoginAt: user.last_login_at ? new Date(user.last_login_at) : undefined,
      createdAt: user.created_at ? new Date(user.created_at) : new Date(),
    }));
  },

  async getById(id: string): Promise<User | null> {
    const { data, error } = await supabase
      .from('users')
      .select('*')
      .eq('id', id)
      .maybeSingle();

    if (error) {
      console.error('Error getting user:', error);
      throw new Error("Impossible de recuperer l'utilisateur");
    }

    if (!data) return null;

    return {
      id: data.id,
      email: data.email,
      role: data.role as UserRole,
      organizationId: data.organization_id,
      displayName: data.display_name,
      avatarUrl: data.avatar_url,
      lastLoginAt: data.last_login_at ? new Date(data.last_login_at) : undefined,
      createdAt: data.created_at ? new Date(data.created_at) : new Date(),
    };
  },
};
